import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { Store } from '@src/store/store';
import { DBConnectionComponentService } from '@src/services';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { databasesActions } from '@src/store/reducers/databasesReducer';

@Component({
    selector: 'database-properties',
    template: require('./database-properties.component.html'),
    styles: [require('./database-properties.component.scss')]
})
export class DatabasePropertiesComponent implements OnInit {
    @Input() public projectId: any;
    @Input() public data: any;

    @Output() public onTest = new EventEmitter<any>();
    @Output() public onSave = new EventEmitter<any>();
    @Output() public onEditLink = new EventEmitter();

    public component: any;
    constructor(private store: Store, private componentService: DBConnectionComponentService) {
    }

    public async ngOnInit() {
        //console.log("db-properties-component");
        await this.store.dispatch({
            type: projectsActions.GET_PROJECT_META_DATA,
            payload: { projId: this.projectId }
        });
        window['dbTypeId'] = this.store.getState().projects.projectWithMetaData.dbTypeId;
        const response = await this.store.dispatch({
            type: databasesActions.GET_CONN_TEMPLATE,
            payload: { dbTypeId: window['dbTypeId'], manageOrUnmanage: 'managed' }
        });
        setTimeout(() => {this.createPage(response);  },200);
    }
    public createPage(response) {
        this.component = this.componentService.createComponent(response.htmlTemplate);
    }

    public setData = (instance: any) => {
        if (this.data) {
            this.data.hasVersionToRm = true;
            this.data.switchTab = async (data: any, tab: any) => {
                if (!data.connectionProperties.lastVisit) {
                    data.connectionProperties.lastVisit = 'Properties';
                }
                const payload = {
                    dbTypeId:  window['dbTypeId'].toString(),
                    connectionProperties: data.connectionProperties
                };
                const response = await this.store.dispatch({ payload, type: databasesActions.SWITCH_TAB });
                if (response) {
                    data.connectionProperties = response;
                    data.connectionProperties.lastVisit = tab;
                }
            };

            instance.isDisabled = true;
            instance.isHidden = true;
            instance.data = this.data;
            instance.onEditLink = this.onEditLink;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-databases/database-properties/database-properties.component.ts